import type { boot } from '@dazn/bootstrap-lib';

import {
    withinRange,
    getUserExperiment,
    getUserExperimentNumber,
    Range,
} from './range';

/**
 * Module responsible for providing a simple data structure that can be exposed to modules to have conditioanl logic for A/B tests. Generated and saves a randomNumber value, and retains it between sessions.
 */
const createExperimentsModule = (
    /**
     * To load the randomNumber value. We invoke it with a key.
     */
    load: boot.storage.AsyncStorage['getItem'],
    /**
     * To save the token to storage. We invoke this with a key and randomNumber value.
     */
    save: boot.storage.AsyncStorage['setItem'],
    /**
     * An hash with all the running A/B tests and randomNumber ranges. Comes from `startupData.AB_Multi_Variant`
     */
    getABData: () => Record<string, Range> | undefined,
    /**
     * Function to retrieve the _viewerId_. It's imported from the target through</br> `() => userModule.getProfile().ViewerId`
     */
    getViewerId: () => string | undefined,
    localStorageKey = 'randomABPoint',
) => {
    let experiments: Record<string, boolean | undefined> = {};
    let randomNumber: number;
    let abData: Record<string, Range>;
    return {
        run: () =>
            load(localStorageKey)
                .then(randomNumberAsString => {
                    randomNumber = Number(String(randomNumberAsString));
                    if (Number.isNaN(randomNumber)) {
                        randomNumber = Math.random();
                        void save(localStorageKey, String(randomNumber));
                    }
                    return randomNumber;
                })
                .then(randomNumber => {
                    window.newrelic?.setCustomAttribute(
                        'randomABPoint',
                        randomNumber,
                    );

                    abData = getABData() ?? {};
                    experiments = Object.keys(abData).reduce<
                        typeof experiments
                    >((acc, key) => {
                        acc[key] = withinRange(randomNumber, abData[key]);
                        return acc;
                    }, {});
                }),
        /**
         * @deprecated
         */
        getExperiments: () => experiments,
        getUserExperiment: (key: string) =>
            getUserExperiment(getViewerId(), abData[key]),
        getUserExperimentNumber: () =>
            getUserExperimentNumber({
                viewerId: getViewerId(),
                randomNumber,
            }),
        getAnonymousExperiment: (key: string) =>
            withinRange(randomNumber, abData[key]),
    };
};

export { createExperimentsModule };
